export default __webpack_public_path__ + "static/media/delivery3.2c70164e.jpg";